export const LABEL_PREVIEW_DEBOUNCE_MS = 280;
